'use client';

import { useEffect } from 'react';
import { onCLS, onINP, onFCP, onLCP, onTTFB, Metric } from 'web-vitals';

// Send Core Web Vitals to analytics service
function sendToAnalytics({ name, value, rating }: Metric) {
  // In development, log to console
  if (process.env.NODE_ENV === 'development') {
    console.log(`[Web Vitals] ${name}:`, { value, rating });
  }

  // In production, send to your analytics service
  if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
    // Example: Google Analytics 4
    // gtag('event', name, {
    //   value: Math.round(name === 'CLS' ? value * 1000 : value),
    //   metric_rating: rating,
    // });

    // Example: Custom analytics endpoint
    // fetch('/api/analytics/web-vitals', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({ name, value, rating }),
    // });
  }
}

export default function WebVitalsReporter() {
  useEffect(() => {
    // Measure Core Web Vitals
    onCLS(sendToAnalytics);
    onINP(sendToAnalytics); // Interaction to Next Paint (replaced FID)
    onFCP(sendToAnalytics);
    onLCP(sendToAnalytics);
    onTTFB(sendToAnalytics);
  }, []);

  return null; // This component doesn't render anything
}